// extracted by mini-css-extract-plugin
export default {"tooltip":"ZP-z","arrow":"_P-z"};